import { toast } from "react-toastify";
import { BasicPage } from "../../../theme/Component/BasicPage"
import { ListMenu } from "../../../theme/Component/ListMenu";
import { useEffect, useState } from "react";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _EcmDocument, _QualityInspection, _single } from "../../../../core/services/dataBean/EntityCatalog";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { AccountEditor } from "../../../editor/AccountEditor";
import useModal, { MODAL_md, MODAL_SM, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { QualityInspectionItems } from "./QualityInspectionItems/QualityInspectionItems";
import usePaginator from "../../../theme/Component/usePaginator";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { PdfDocuments } from "../../../documents/PdfDocuments";

interface formProps {
    State: number
}

export const QualityInspection = () => {

    const { instance, bean, setBean, lista, setLista } = useDataBean(_QualityInspection);
    const signed = useDataBean(_EcmDocument);

    const [formData, setFormData] = useState<Partial<formProps>>({
    })
    const paginador = usePaginator();

    const Pending = 1;
    const Approved = 5;
    const Delete = 6;

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const modalChange = useModal("", MODAL_SM);
    const modalInspections = useModal("Inspecciones Realizadas", MODAL_XL);
    const modalDocument = useModal("Solicitar flujo de firmas", MODAL_md);
    const modalSeeDocument = useModal("Ver Documento", MODAL_XL);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {
        instance.getQualityInspectionRender(paginador.page, 15, formData).then((resp: any) => {
            paginador.setPages(resp.NumberOfPages);
            paginador.setRecords(resp.NumberOfPages * 15);

            resp.List.forEach(element => {
                const value = element.DataBeanProperties;

                value.EntitySupplier = value.NitAccountSupplier ? `${value.NitAccountSupplier} - ${value.AccountSupplierEntityName}` : "N/A";
            });
            setLista(resp.List);
        }).catch(err => {
            toast.error(err);
        });
    };

    const create = () => {
        setBean({
            State: Pending,
            IDEmployee: _single.getAccountID(),
            FromDate: _single.getCurrenDate(),

        });
        setModal({ ...modal, "name": `Agregar Inspección de Insumo`, "view": true });
    }

    const changeStateItem = (newState: number) => {
        let x = bean;
        if (newState == Approved || newState == Delete) {
            x = { ...bean, State: newState, UptoDate: _single.getCurrenDate() };
        } else {
            x = { ...bean, State: newState, UptoDate: _single.getCurrenDate() };
        }

        editaItem(x);
    };

    const editaItem = (obj: any) => {
        instance.updateQualityInspection(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                modalChange.close();
                modalDocument.close();
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDQualityInspection', visible: true },
        { title: 'Proveedor', property: 'EntitySupplier', visible: true },
        { title: 'Tipo de Tela', property: 'ClothType', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },
        { title: 'Fecha', property: 'FromDate', visible: true },
    ];


    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const [confirmAction, setConfirmAction] = useState<() => void>(() => () => { });

    const openConfirm = (text: string, fn: () => void) => {
        setConfirmAction(() => fn);
        modalChange.open(text)
    };

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit() && bean.State == Pending, evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete() && bean.State == Pending, evento: () => { openConfirm("Confirmar Aprobación", () => changeStateItem(Delete)) } },
            { titulo: 'Solicitar Aprobaciones', icono: 'mdi mdi-signature-text', visible: _single.canEdit(), evento: () => { modalDocument.open() } },
            { titulo: 'Ver Documento', icono: 'mdi mdi-folder-eye-outline', visible: bean.IDDocument, evento: () => { modalSeeDocument.open() } },
            { titulo: 'Ver Inspecciones Realizadas', icono: 'ri-list-check', visible: _single.canCreate(), evento: () => { modalInspections.open(`Inspecciones Realizadas de ${bean.IDQualityInspection}`) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const [missingFields, setMissingFields] = useState<string[]>([]);

    const validateData = () => {
        if (validateForm() > 0) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            editaItem(bean);
        }
    }

    const validateForm = () => {
        const requiredFields = [
            "IDAccountSupplier", "Observations"
        ];
        let missing = [];
        for (let field of requiredFields) {
            if (bean[field] === null || bean[field] === undefined || bean[field] === "") {
                missing.push(field);
            }
        }
        setMissingFields(missing);
        return missing.length;
    };

    const validateDataSigned = () => {
        if (!signed.bean.IDSignPanel) {
            toast.error("Faltan campos obligatorios por completar");
            return;
        } else {
            createEcmDocumentForFlowControl();
        }
    }

    const createEcmDocumentForFlowControl = () => {

        const Obs = `Durante la inspección de insumos se procedió a la revisión del lote de telas de parte del proveedor ${bean.EntitySupplier}, provenientes de la ${bean.TypoDocumentoName} No ${bean.NoDocumento}, verificando su estado, características físicas y cumplimiento con las especificaciones técnicas establecidas. Se deja constancia de la inspección realizada y se solicita la firma del presente documento como validación del proceso y continuidad del control de calidad.`

        signed.instance.createEcmDocumentForFlowControl(signed.bean.IDSignPanel, _single.getAccountID(), Obs, null, null, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                if (resp.IDDocument > 0) {
                    signed.instance.fireSigningDocumentFlow(resp.IDDocument, resp.Mnemonic, resp.DocumentDate, signed.bean.IDSignPanel, _single.getAccountID()).then(
                        (resp: any) => {
                            toast.success(resp);
                            console.log(resp)
                        }
                    ).catch(
                        err => {
                            toast.error("No se pudo iniciar proceso de firmas")
                        }
                    )
                    editaItem({ ...bean, IDDocument: resp.IDDocument, DocumentDate: resp.DocumentDate })
                } else {
                    toast.error("No se genero documentoa firmar")
                }
            }).catch(
                err => { toast.error(err) }
            )
    }

    return (
        <BasicPage titulo="Inspección de Calidad - Insumos">
            <div className="row">
                <div className="col-md-4">
                    <label >Estado</label>
                    <select className="form-select" value={formData.State} onChange={(e) => {
                        const value = e.target.value ? Number(e.target.value) : null
                        setFormData({ ...formData, State: value })
                    }} >
                        <option value="">...</option>
                        <option value={Pending}>Creado</option>
                        <option value={Delete}>Eliminado</option>
                    </select>
                </div>
                <div className="col-md-2">
                    <BasicButton eventClick={() => { getLista() }} icon="ri-search-line" children={"Buscar"} useMargin />
                </div>
                <div className="col-md-12">
                    <BasicTable
                        body={lista}
                        head={head}
                        rowSet={setBean}
                        listButtons={listaBotones()}
                        iconButtons={iconButtonsItem}
                        pageTop={paginador.page}
                        next={paginador.next}
                        back={paginador.back}
                        records={paginador}
                    />

                    <Modal modal={modal} updateModal={setModal} eventModal={() => { validateData() }}>
                        <div className="row">
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('IDAccountSupplier') ? 'has-error' : ''}`} >Proveedor</label>
                                <AccountEditor idAccount={bean.IDAccountSupplier} label=" " onChange={(e) => { setBean({ ...bean, IDAccountSupplier: e.IDAccount }) }} />
                            </div>
                            <div className="col-md-6">
                                <label className={`${missingFields.includes('ClothType') ? 'has-error' : ''}`} >Tipo de Tela</label>
                                <input type="text" className="form-control" value={bean.ClothType} onChange={(e) => { setBean({ ...bean, ClothType: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Observations') ? 'has-error' : ''}`} >Observaciones</label>
                                <textarea className="form-control" value={bean.Observations} onChange={(e) => { setBean({ ...bean, Observations: e.target.value }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalInspections.modal} updateModal={modalInspections.setModal}  >
                        <QualityInspectionItems QualityInspection={bean} />
                    </Modal>

                    <Modal modal={modalDocument.modal} updateModal={modalDocument.setModal} eventModal={() => { validateDataSigned() }}  >
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('IDSignPanel') ? 'has-error' : ''}`}>Panel de Firma</label>
                            <SingPanelEditor idSelector={signed.bean.IDSignPanel} label=" " onChange={(e) => { signed.setBean({ ...signed.bean, "IDSignPanel": e }) }} />
                        </div>
                    </Modal>

                    <Modal modal={modalSeeDocument.modal} updateModal={modalSeeDocument.setModal}   >
                        <PdfDocuments documentLocation={bean.IDDocument} date={bean.DocumentDate} mnemonic="ECM" />
                    </Modal>

                    <ModalConfirm modal={modalChange.modal} updateModal={modalChange.setModal} eventModal={() => { confirmAction() }}>
                        <strong>¿Desea Continuar con la accion?</strong>
                    </ModalConfirm>

                </div>
            </div>
        </BasicPage>
    )
}